import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import VariantsInformation from './components/VariantsInformation';
import ItemInformation from './components/ItemInformation';
import ShowContainer from '../../shared/components/show/ShowContainer';

const Index = () => (
  <Container>
    <ShowContainer>
      {
        (resourceitem) => {
          if (Object.keys(resourceitem).length === 0) return null;
          return (
            <Container>
              <ItemInformation resourceitem={resourceitem} />
              <hr />
              <VariantsInformation resourceitem={resourceitem} />
            </Container>
          );
        }
      }
    </ShowContainer>
  </Container>
);

export default withRouter(connect()(Index));
